import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 1,
    "name": "Slovenský jazyk",
    "locale": "sk",
    "image": {
      "id": 1,
      "name": "sk.svg",
      "url": "https://api.ubytovaniestrba.sk/files/sk.svg?ai=0",
      "custom_title": "sk",
      "is_ai_generated": false
    },
    "is_default": true
  },
  {
    "id": 2,
    "name": "Český jazyk",
    "locale": "cs",
    "image": {
      "id": 2,
      "name": "cz.svg",
      "url": "https://api.ubytovaniestrba.sk/files/cz.svg?ai=0",
      "custom_title": "cz",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 3,
    "name": "Anglický jazyk",
    "locale": "en",
    "image": {
      "id": 3,
      "name": "gb.svg",
      "url": "https://api.ubytovaniestrba.sk/files/gb.svg?ai=0",
      "custom_title": "gb",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 4,
    "name": "Poľský jazyk",
    "locale": "pl",
    "image": {
      "id": 4,
      "name": "pl.svg",
      "url": "https://api.ubytovaniestrba.sk/files/pl.svg?ai=0",
      "custom_title": "pl",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 5,
    "name": "Maďarský jazyk",
    "locale": "hu",
    "image": {
      "id": 5,
      "name": "hu.svg",
      "url": "https://api.ubytovaniestrba.sk/files/hu.svg?ai=0",
      "custom_title": "hu",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 6,
    "name": "Španielský jazyk",
    "locale": "es",
    "image": {
      "id": 6,
      "name": "es.svg",
      "url": "https://api.ubytovaniestrba.sk/files/es.svg?ai=0",
      "custom_title": "es",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 7,
    "name": "Francúzsky jazyk",
    "locale": "fr",
    "image": {
      "id": 7,
      "name": "fr.svg",
      "url": "https://api.ubytovaniestrba.sk/files/fr.svg?ai=0",
      "custom_title": "fr",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 8,
    "name": "Chorvatský jazyk",
    "locale": "hr",
    "image": {
      "id": 8,
      "name": "hr.svg",
      "url": "https://api.ubytovaniestrba.sk/files/hr.svg?ai=0",
      "custom_title": "hr",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 9,
    "name": "Talianský jazyk",
    "locale": "it",
    "image": {
      "id": 9,
      "name": "it.svg",
      "url": "https://api.ubytovaniestrba.sk/files/it.svg?ai=0",
      "custom_title": "it",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 10,
    "name": "Nemecký jazyk",
    "locale": "de",
    "image": {
      "id": 10,
      "name": "de.svg",
      "url": "https://api.ubytovaniestrba.sk/files/de.svg?ai=0",
      "custom_title": "de",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 11,
    "name": "Belgický jazyk",
    "locale": "be",
    "image": {
      "id": 11,
      "name": "be.svg",
      "url": "https://api.ubytovaniestrba.sk/files/be.svg?ai=0",
      "custom_title": "be",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 12,
    "name": "Bulharský jazyk",
    "locale": "bg",
    "image": {
      "id": 12,
      "name": "bg.svg",
      "url": "https://api.ubytovaniestrba.sk/files/bg.svg?ai=0",
      "custom_title": "bg",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 13,
    "name": "Grécky jazyk",
    "locale": "gr",
    "image": {
      "id": 13,
      "name": "gr.svg",
      "url": "https://api.ubytovaniestrba.sk/files/gr.svg?ai=0",
      "custom_title": "gr",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 14,
    "name": "Švédsky jazyk",
    "locale": "se",
    "image": {
      "id": 14,
      "name": "se.svg",
      "url": "https://api.ubytovaniestrba.sk/files/se.svg?ai=0",
      "custom_title": "se",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 15,
    "name": "Fínsky jazyk",
    "locale": "fi",
    "image": {
      "id": 15,
      "name": "fi.svg",
      "url": "https://api.ubytovaniestrba.sk/files/fi.svg?ai=0",
      "custom_title": "fi",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 16,
    "name": "Dánsky jazyk",
    "locale": "dk",
    "image": {
      "id": 16,
      "name": "dk.svg",
      "url": "https://api.ubytovaniestrba.sk/files/dk.svg?ai=0",
      "custom_title": "dk",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 17,
    "name": "Nórsky jazyk",
    "locale": "nr",
    "image": {
      "id": 17,
      "name": "nr.svg",
      "url": "https://api.ubytovaniestrba.sk/files/nr.svg?ai=0",
      "custom_title": "nr",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 18,
    "name": "Ruský jazyk",
    "locale": "ru",
    "image": {
      "id": 18,
      "name": "ru.svg",
      "url": "https://api.ubytovaniestrba.sk/files/ru.svg?ai=0",
      "custom_title": "ru",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 19,
    "name": "Rumunsky jazyk",
    "locale": "ro",
    "image": {
      "id": 19,
      "name": "ro.svg",
      "url": "https://api.ubytovaniestrba.sk/files/ro.svg?ai=0",
      "custom_title": "ro",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 20,
    "name": "Holandský jazyk",
    "locale": "nl",
    "image": {
      "id": 20,
      "name": "nl.svg",
      "url": "https://api.ubytovaniestrba.sk/files/nl.svg?ai=0",
      "custom_title": "nl",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 21,
    "name": "Slovínsky jazyk",
    "locale": "si",
    "image": {
      "id": 21,
      "name": "si.svg",
      "url": "https://api.ubytovaniestrba.sk/files/si.svg?ai=0",
      "custom_title": "si",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 22,
    "name": "Rakúsky jazyk",
    "locale": "at",
    "image": {
      "id": 22,
      "name": "at.svg",
      "url": "https://api.ubytovaniestrba.sk/files/at.svg?ai=0",
      "custom_title": "at",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 23,
    "name": "Brazílsky jazyk",
    "locale": "br",
    "image": {
      "id": 23,
      "name": "br.svg",
      "url": "https://api.ubytovaniestrba.sk/files/br.svg?ai=0",
      "custom_title": "br",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 24,
    "name": "Portugalský jazyk",
    "locale": "pt",
    "image": {
      "id": 24,
      "name": "pt.svg",
      "url": "https://api.ubytovaniestrba.sk/files/pt.svg?ai=0",
      "custom_title": "pt",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 25,
    "name": "Ukrainský jazyk",
    "locale": "ua",
    "image": {
      "id": 25,
      "name": "ua.svg",
      "url": "https://api.ubytovaniestrba.sk/files/ua.svg?ai=0",
      "custom_title": "ua",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 26,
    "name": "Turecký jazyk",
    "locale": "tr",
    "image": {
      "id": 26,
      "name": "tr.svg",
      "url": "https://api.ubytovaniestrba.sk/files/tr.svg?ai=0",
      "custom_title": "tr",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 27,
    "name": "Estónsky jazyk",
    "locale": "ee",
    "image": {
      "id": 27,
      "name": "ee.svg",
      "url": "https://api.ubytovaniestrba.sk/files/ee.svg?ai=0",
      "custom_title": "ee",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 29,
    "name": "Lotyšský jazyk",
    "locale": "lv",
    "image": {
      "id": 28,
      "name": "lv.svg",
      "url": "https://api.ubytovaniestrba.sk/files/lv.svg?ai=0",
      "custom_title": "lv",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 30,
    "name": "Americký jazyk",
    "locale": "us",
    "image": {
      "id": 29,
      "name": "us.svg",
      "url": "https://api.ubytovaniestrba.sk/files/us.svg?ai=0",
      "custom_title": "us",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 31,
    "name": "Austrálsky jazyk",
    "locale": "au",
    "image": {
      "id": 30,
      "name": "au.svg",
      "url": "https://api.ubytovaniestrba.sk/files/au.svg?ai=0",
      "custom_title": "au",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 32,
    "name": "Kanadský jazyk",
    "locale": "ca",
    "image": {
      "id": 31,
      "name": "ca.svg",
      "url": "https://api.ubytovaniestrba.sk/files/ca.svg?ai=0",
      "custom_title": "ca",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 33,
    "name": "Švajčiarsky jazyk",
    "locale": "ch",
    "image": {
      "id": 32,
      "name": "ch.svg",
      "url": "https://api.ubytovaniestrba.sk/files/ch.svg?ai=0",
      "custom_title": "ch",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 34,
    "name": "Indický jazyk",
    "locale": "in",
    "image": {
      "id": 33,
      "name": "in.svg",
      "url": "https://api.ubytovaniestrba.sk/files/in.svg?ai=0",
      "custom_title": "in",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 35,
    "name": "Japonský jazyk",
    "locale": "jp",
    "image": {
      "id": 34,
      "name": "jp.svg",
      "url": "https://api.ubytovaniestrba.sk/files/jp.svg?ai=0",
      "custom_title": "jp",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 36,
    "name": "Mexický jazyk",
    "locale": "mx",
    "image": {
      "id": 35,
      "name": "mx.svg",
      "url": "https://api.ubytovaniestrba.sk/files/mx.svg?ai=0",
      "custom_title": "mx",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 37,
    "name": "Srbský jazyk",
    "locale": "rs",
    "image": {
      "id": 36,
      "name": "rs.svg",
      "url": "https://api.ubytovaniestrba.sk/files/rs.svg?ai=0",
      "custom_title": "rs",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 38,
    "name": "Bosna a Hercegovina jazyk",
    "locale": "ba",
    "image": {
      "id": 37,
      "name": "ba.svg",
      "url": "https://api.ubytovaniestrba.sk/files/ba.svg?ai=0",
      "custom_title": "ba",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 39,
    "name": "Litovský jazyk",
    "locale": "lt",
    "image": {
      "id": 38,
      "name": "lt.svg",
      "url": "https://api.ubytovaniestrba.sk/files/lt.svg?ai=0",
      "custom_title": "lt",
      "is_ai_generated": false
    },
    "is_default": false
  }
];
